<template>
  <section
    class="features-tiles section center-content"
    :class="[
      hasBgColor && 'has-bg-color',
      invertColor && 'invert-color'
    ]">
    <div class="container">
      <div
        class="features-tiles-inner section-inner"
        :class="[
          topDivider && 'has-top-divider',
          bottomDivider && 'has-bottom-divider'
        ]">
        <c-section-header :data="sectionHeader" class="center-content" />
        <div
          class="tiles-wrap"
          :class="[
            pushLeft && 'push-left',
          ]">
          <div class="tiles-item">
            <div class="tiles-item-inner">
              <div class="features-tiles-item-header">
                <div class="features-tiles-item-image primary-color mb-16 reveal-rotate-from-right" data-reveal-container=".tiles-item">
                  <img
                    :src="require('@/assets/images/feature-tile-icon-01.svg')"
                    alt="React In Real Time" />
                </div>
              </div>
              <div class="features-tiles-item-content">
                <h4 class="mt-0 mb-8 reveal-from-left" data-reveal-delay="200" data-reveal-container=".tiles-item">
                  Learn What Your Customers REALLY Want
                </h4>
                <p class="m-0 text-sm reveal-from-left" data-reveal-delay="400" data-reveal-container=".tiles-item">
                  Empower your product roadmap with real-time data on your users' biggest pain points.
                </p>
              </div>
            </div>
          </div>

          <div class="tiles-item">
            <div class="tiles-item-inner">
              <div class="features-tiles-item-header">
                <div class="features-tiles-item-image secondary-color mb-16 reveal-rotate-from-right" data-reveal-container=".tiles-item">
                  <img
                    :src="require('@/assets/images/feature-tile-icon-02.svg')"
                    alt="Faster Growth By Reducing Churn" />
                </div>
              </div>
              <div class="features-tiles-item-content">
                <h4 class="mt-0 mb-8 reveal-from-bottom" data-reveal-delay="200" data-reveal-container=".tiles-item">
                  Catch Customers Before They Leave
                </h4>
                <p class="m-0 text-sm reveal-from-bottom" data-reveal-delay="400" data-reveal-container=".tiles-item">
                  SLASH your churn rate. Prevent cancellations with the ability to intervene at customers' riskiest moments.
                </p>
              </div>
            </div>
          </div>

          <div class="tiles-item">
            <div class="tiles-item-inner">
              <div class="features-tiles-item-header">
                <div class="features-tiles-item-image primary-color mb-16 reveal-rotate-from-right" data-reveal-container=".tiles-item">
                  <img
                    :src="require('@/assets/images/feature-tile-icon-03.svg')"
                    alt="Feature tile icon 03" />
                </div>
              </div>
              <div class="features-tiles-item-content">
                <h4 class="mt-0 mb-8 reveal-from-right" data-reveal-delay="200" data-reveal-container=".tiles-item">
                  Drive Customer Satisfaction
                </h4>
                <p class="m-0 text-sm reveal-from-right" data-reveal-delay="400" data-reveal-container=".tiles-item">
                  Offramp intervenes at your customers' moment of peak need, and it can help connect them instantly to the most helpful resource.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { SectionTilesProps } from '@/utils/SectionProps.js'
import CSectionHeader from '@/components/sections/partials/SectionHeader.vue'

export default {
 name: 'CFeaturesTiles',
 components: {
  CSectionHeader
 },
 mixins: [SectionTilesProps],
 data() {
  return {
   sectionHeader: {
    title: '',
    paragraph: ''
   }
  }
 }
}
</script>